export enum FeeTypes {
  TICKET = 'ticket',
  ONLINE = 'online',
  CONTRACTS = 'contracts'
}